import { InfoCircleFilled } from '@ant-design/icons';
import { clsx } from 'clsx';
import React from 'react';

interface InfoBannerCardProps {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
}

export default function InfoBannerCard({
  children,
  className,
  contentClassName,
}: InfoBannerCardProps) {
  return (
    <div
      className={clsx(
        'flex items-start gap-3 rounded border border-bleu-hellio-2 bg-bleu-hellio-1 px-4 py-3 sm:px-6 sm:py-5',
        className,
      )}
    >
      <InfoCircleFilled className="mt-1 text-base text-bleu-hellio" />
      <div
        className={clsx(
          'space-y-4 font-fieldwork text-sm text-gris-hellio',
          contentClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
}
